import { OTSOrder } from "../../contexts/types/types";
import { Contact } from "../types/Contact";
import { MatchedOrder, MatchedProperty, Buyer } from "./MatchedOrder";

export function mapOTSOrderToMatchedOrder(order: OTSOrder): MatchedOrder {
  const parcel = order.parcelInfo;

  const matchedProperty: MatchedProperty = {
    address1: `${parcel.streetNumber} ${parcel.streetName}`.trim(),
    address2: parcel.unit || "",
    city: parcel.city,
    state: parcel.state,
    zip: parcel.postalCode,
    county: parcel.countyName,
    section: parcel.section,
    block: parcel.block,
    lots: [parcel.lot],
    parcelIds: [parcel.apn],
    propertyUse: "",
    legalDescription: {
      description: null,
      lookupCode: null
    }
  };

  const buyerParties = order.parties.filter((p) => p.partyType === "Buyer");

  const buyers: Buyer[] = buyerParties.map((party) => ({
    individual: {
      firstName: party.firstName || null,
      middleName: party.middleName || null,
      lastName: party.lastName || null,
      gender: null,
      address: null
    },
    organization: {
      name: null,
      organizationType: null,
      payeeName: null,
      attorneyLookupCode: null,
      address: null
    },
    joint: {
      relationshipType: null,
      jointOne: {
        firstName: null,
        middleName: null,
        lastName: null,
        gender: null,
        attorneyLookupCode: null,
        address: null
      },
      jointTwo: {
        firstName: null,
        middleName: null,
        lastName: null,
        gender: null,
        attorneyLookupCode: null,
        address: null
      }
    }
  }));

  const sellerParty = order.parties.find((p) => p.partyType === "Seller");

  const principal: Contact = {
    id: null,
    firstName: sellerParty?.firstName || null,
    middleName: sellerParty?.middleName || null,
    lastName: sellerParty?.lastName || null,
    name: sellerParty
      ? [sellerParty.firstName, sellerParty.middleName, sellerParty.lastName].filter(Boolean).join(" ")
      : null,
    suffix: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip: null,
    salesRep: null,
    njAccountRep: null,
    nyAccountRep: null,
    njCommercialAccountRep: null,
    nationalAccountRep: null,
    internalDriverEmail: null,
    internalDriverPhone: null,
    clientInstructions: null,
    whoHasTheFile: null
  };

  return {
    identifier: order.orderInfo.orderNumber,
    number: order.orderInfo.orderNumber,
    regionCode: parcel.state,
    transactionType: order.orderInfo.transactionType,
    properties: [matchedProperty],
    propertyUse: "",
    titleCode: "",
    buyers: {
      attorney: {
        id: null,
        suffix: null,
        salesRep: null,
        njAccountRep: null,
        njCommercialAccountRep: null,
        nyAccountRep: null,
        nationalAccountRep: null,
        internalDriverEmail: null,
        internalDriverPhone: null,
        clientInstructions: null,
        whoHasTheFile: null
      },
      buyers
    },
    principal,
    priorPolicy: null
  };
}
